export const PAYROLL_HISTORY_START_MONTH = "2025-04";

const MONTH_NUMBERS = {
  jan: 1,
  january: 1,
  feb: 2,
  february: 2,
  mar: 3,
  march: 3,
  apr: 4,
  april: 4,
  may: 5,
  jun: 6,
  june: 6,
  jul: 7,
  july: 7,
  aug: 8,
  august: 8,
  sep: 9,
  sept: 9,
  september: 9,
  oct: 10,
  october: 10,
  nov: 11,
  november: 11,
  dec: 12,
  december: 12,
};

const monthKey = (year, month) => {
  const yearNumber = Number(year);
  const monthNumber = Number(month);

  if (!Number.isInteger(yearNumber) || !Number.isInteger(monthNumber) || monthNumber < 1 || monthNumber > 12) {
    return "";
  }

  return `${yearNumber}-${String(monthNumber).padStart(2, "0")}`;
};

export const getPayrollMonthKey = (slip) => {
  const periodKey = String(slip?.periodKey || "").trim();
  const periodKeyMatch = periodKey.match(/^(\d{4})-(\d{1,2})$/);
  if (periodKeyMatch) {
    return monthKey(periodKeyMatch[1], periodKeyMatch[2]);
  }

  const period = String(slip?.period || "").trim().toLowerCase();
  const periodMatch = period.match(/^([a-z]+)\s+(\d{4})$/);
  if (periodMatch && MONTH_NUMBERS[periodMatch[1]]) {
    return monthKey(periodMatch[2], MONTH_NUMBERS[periodMatch[1]]);
  }

  const payDate = new Date(slip?.payDate || "");
  if (!Number.isNaN(payDate.getTime())) {
    return monthKey(payDate.getFullYear(), payDate.getMonth() + 1);
  }

  return "";
};

export const filterEmployeePayrollHistory = (slips, today = new Date()) => {
  const currentMonth = monthKey(today.getFullYear(), today.getMonth() + 1);

  return (Array.isArray(slips) ? slips : []).filter((slip) => {
    const slipMonth = getPayrollMonthKey(slip);
    return Boolean(slipMonth && slipMonth >= PAYROLL_HISTORY_START_MONTH && slipMonth <= currentMonth);
  });
};
